import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPurchaseOrders = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase orders:", error);
    throw error;
  }
};

export const savePurchaseOrder = async (purchaseOrder) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/save`, purchaseOrder, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    // Handle validation errors (400 BadRequest) from backend
    if (error.response && error.response.status === 400 && error.response.data) {
      // Return the error response data so frontend can display the validation message
      return error.response.data;
    }
    // For other errors, throw to be caught by the calling function
    console.error("Error saving purchase order:", error);
    throw error;
  }
};

export const getNextInvoiceNo = async (businessId, isReturn = false, returnOriginalInvoiceNo = null) => {
  try {
    const payload = {
      Business_Id: businessId,
      IsReturn: isReturn
    };
    
    if (isReturn && returnOriginalInvoiceNo) {
      payload.Return_Original_InvoiceNo = returnOriginalInvoiceNo;
    }
    
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-next-invoice-no`, payload, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting next invoice number:", error);
    throw error;
  }
};

// NEW: Get a single purchase return by id (read-only view)
export const getPurchaseReturnById = async (purchaseReturnId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-return-by-id`, {
      PurchaseReturn_Id: purchaseReturnId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting purchase return by id:", error);
    throw error;
  }
};

export const getPurchaseOrderForReturn = async (purchaseOrderId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-purchase-order-for-return`, {
      PurchaseOrder_Id: purchaseOrderId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase order for return:", error);
    throw error;
  }
};

